export default __webpack_public_path__ + "static/media/dollar-sign-solid.8b6178ae.svg";